var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47442 1.0005C1.25129 1.0213 1.06597 1.18024 1.01416 1.39647C0.962344 1.61224 1.0557 1.83726 1.24569 1.95461L9.50429 7.16179L7.0536 13.226C6.97985 13.4159 7.02513 13.6312 7.16983 13.7754C7.31407 13.92 7.53067 13.9676 7.72346 13.8969L12.0124 12.2474L13.5972 15.7003C13.6765 15.8694 13.8413 15.983 14.029 15.9983C14.2166 16.0135 14.3982 15.9271 14.5037 15.7733L23.9148 1.80122C24.0194 1.64274 24.0283 1.44083 23.9382 1.27403C23.8481 1.10723 23.673 1.00235 23.4821 1.00097H1.52344C1.5071 1.00004 1.49076 0.99958 1.47442 1.0005ZM3.31268 2.03547H20.827L10.191 6.36939L3.31268 2.03547ZM22.0929 2.63381L14.1606 14.4306L12.7803 11.431C12.7719 11.4028 12.7607 11.376 12.7476 11.3502L12.7392 11.334V11.3257L10.8519 7.22647L22.0929 2.63381ZM10.1826 8.26144L11.5797 11.31L8.45913 12.5066L10.1826 8.26144Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.dbb69ecf11643586f1a00c879661295e.svg";
export { ForwardRef as ReactComponent };